<script setup>
import { ESCOPOS_DA_ETIQUETA } from 'dashboard/helper/escopoDaEtiqueta';

const ondeUsar = defineModel({ type: String, default: 'all' });
</script>

<template>
  <div class="w-full">
    <label for="label-applies-to">
      {{ $t('LABEL_MGMT.FORM.APPLIES_TO.LABEL') }}
      <select
        id="label-applies-to"
        v-model="ondeUsar"
        data-testid="label-applies-to"
      >
        <option
          v-for="escopo in ESCOPOS_DA_ETIQUETA"
          :key="escopo"
          :value="escopo"
        >
          {{ $t(`LABEL_MGMT.FORM.APPLIES_TO.OPTIONS.${escopo}`) }}
        </option>
      </select>
    </label>
    <p class="mt-1 mb-0 text-xs text-n-slate-11">
      {{ $t('LABEL_MGMT.FORM.APPLIES_TO.HELP') }}
    </p>
  </div>
</template>
